import React from "react";

export default function NormalMessage({ message, isMe, time_human }) {
  return (
    <div
      style={{
        ...styles.container,
        alignSelf: isMe ? "flex-end" : "flex-start",
      }}
    >
      <div
        style={{
          ...styles.bubble,
          backgroundColor: isMe ? "#4e8cff" : "#333",
          borderTopRightRadius: isMe ? 0 : 12,
          borderTopLeftRadius: isMe ? 12 : 0,
        }}
      >
        {message.message.message}
      </div>
      <div style={styles.timestamp}>
        {time_human}
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "0.5rem",
    maxWidth: "70%",
  },
  bubble: {
    padding: "0.6rem 1rem",
    color: "#fff",
    borderRadius: 12,
    fontSize: "0.95rem",
    wordBreak: "break-word",
  },
  timestamp: {
    fontSize: "0.75rem",
    color: "#aaa",
    marginTop: "0.25rem",
    alignSelf: "flex-end",
  },
};